import { create } from "zustand";

// 図形の移動に追従するコメントピンの「確定前アンカー」を保持する一時 store。
//
// オブジェクトのドラッグは DOM の left/top を直接書き換えてプレビューし、pointerup まで doc store
// へ反映しない。コメントピンは通常オブジェクト層（canvas-objects-layer）に描画されず、直書き対象の
// DOM を持たないため、この store 経由で確定前アンカーをコメント層へ渡してプレビュー追従させる。
//
// 追従対象にコメントが 1 件も無いドラッグでは一度も書き込まないため、anchors は空オブジェクトのまま
// 参照が変わらず、CommentLayer は再描画されない（connector-drag-store を購読して代替すると、
// 無関係なドラッグでも毎 pointermove で再描画される）。

export interface CommentAnchorPreview {
  readonly x: number;
  readonly y: number;
}

interface CommentAnchorPreviewState {
  /** 追従中コメントスレッドの確定前アンカー（ステージ座標）。 */
  readonly anchors: Record<string, CommentAnchorPreview>;
  /** 複数スレッドの確定前アンカーをまとめて設定（既存分へマージ）する。 */
  readonly setAnchors: (updates: Record<string, CommentAnchorPreview>) => void;
  /** 指定 id の確定前アンカーを取り除く（pointerup での確定後・中断の後始末で呼ぶ）。 */
  readonly clearAnchors: (ids: readonly string[]) => void;
}

export const useCommentAnchorPreviewStore = create<CommentAnchorPreviewState>((set) => ({
  anchors: {},
  setAnchors: (updates) => set((state) => ({ anchors: { ...state.anchors, ...updates } })),
  clearAnchors: (ids) =>
    set((state) => {
      if (ids.length === 0) return state;
      let changed = false;
      const next = { ...state.anchors };
      for (const id of ids) {
        if (id in next) {
          delete next[id];
          changed = true;
        }
      }
      return changed ? { anchors: next } : state;
    }),
}));
